import '../../../js/lib/jquery.min'
import CustomSoundCloudPlayer from '../../../js/player.js'

var soundCloudUrl = '/john-pdf/hus-hus'
var playerSc = new CustomSoundCloudPlayer(soundCloudUrl)
